import Button from "components/common/Button/Button";
import ThreeDots from "components/common/Loader/ThreeDots";
import * as React from "react";

interface IProps {
  sending: boolean;
  sendCustomerWalletDetailsBySMS(): void;
}

const SendCustomerWalletDetails: React.SFC<IProps> = ({
  sendCustomerWalletDetailsBySMS,
  sending
}) => (
  <>
    {sending ? (
      <div
        style={{
          display: "inline-block",
          padding: "0px 22px"
        }}
      >
        <ThreeDots />
      </div>
    ) : (
      <Button primary onClick={sendCustomerWalletDetailsBySMS}>
        Text me my wallet info
      </Button>
    )}
  </>
);
export default SendCustomerWalletDetails;



// WEBPACK FOOTER //
// ./src/screens/Main/edit-profile/blockchain/SendCustomerWalletDetails.tsx